const constant = {
  keepLimit: 1800000
};

export default constant;
